import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center min-h-screen bg-neutral-800 text-neutral-50" }
const _hoisted_2 = {
  key: 0,
  class: "relative flex flex-col items-center gap-8"
}
const _hoisted_3 = { class: "flex flex-col items-center gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " The active bonus skill is ", -1)
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "text-2xl capitalize" }
const _hoisted_8 = { class: "lg:absolute lg:-right-80 lg:top-1/2 lg:-translate-y-1/2 flex flex-col gap-2 w-48 text-sm" }
const _hoisted_9 = { class: "flex items-center gap-2 px-2" }
const _hoisted_10 = { class: "flex justify-center items-center w-4 h-4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Skill order ", -1)
const _hoisted_13 = { class: "flex flex-col gap-2 py-2 border-y border-neutral-50" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text-xs text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.activeBonusSkill)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.activeBonusSkill.name === '?' ? 'bg-neutral-900 rounded-full' : '', "flex justify-center items-center w-10 h-10"])
              }, [
                (_ctx.activeBonusSkill.name !== '?')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require(`@/assets/images/${_ctx.activeBonusSkill.name}.png`),
                      alt: _ctx.activeBonusSkill.name,
                      class: "max-w-full max-h-full"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.activeBonusSkill.name), 1)
            ]),
            _createElementVNode("p", null, " Time left: " + _toDisplayString(_ctx.timeLeft), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: require(`@/assets/images/stats.png`),
                  alt: "stats",
                  class: "max-w-full max-h-full"
                }, null, 8, _hoisted_11)
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillOrder, (skill, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center justify-between px-2"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass([skill.name === '?' ? 'bg-neutral-900 rounded-full' : '', "flex justify-center items-center w-4 h-4"])
                    }, [
                      (skill.name !== '?')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require(`@/assets/images/${skill.name}.png`),
                            alt: skill.name,
                            class: "max-w-full max-h-full"
                          }, null, 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("p", {
                      class: _normalizeClass([skill.id === _ctx.activeBonusSkill.id ? 'text-green-400' : '', "capitalize"])
                    }, _toDisplayString(skill.name), 3)
                  ]),
                  (skill.id !== _ctx.activeBonusSkill.id && skill.nextTimestamp)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.getLocalTime(skill.nextTimestamp)), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_17, " Last updated on " + _toDisplayString(_ctx.lastUpdated), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}